import React from 'react';
import { WORK_WITH_US } from '../../config/links/links';

const HeaderTop = () => {
  return (
    <>
      <div className="row top-block align-items-center">
        <div className="col text-center">
          <div
            aria-label="welcome text"
            className="welcome-container"
            data-qa="welcome"
          >
            Hello There!
          </div>
        </div>
        <div className="d-flex col-auto align-items-end">
          <div className="advertise-link-container">
            <a
              aria-label="Advertise Link"
              data-qa="advertiseLink"
              href={WORK_WITH_US}
              rel="noreferrer noopener"
              target="_blank"
            >
              Advertise
            </a>
          </div>
        </div>
      </div>
      <style jsx>{`
        .top-block {
          padding-top: 10px;
        }
        .welcome-container {
          text-align: center;
          color: #eb008c;
          font-size: 12px;
          text-transform: capitalize;
          margin-left: 16%;
        }
        .advertise-link-container {
          text-align: center;
          font-size: 12px;
        }
        .advertise-link-container > a {
          text-decoration: none;
          color: #eb008c;
        }
      `}</style>
    </>
  );
};

export default HeaderTop;
